module.exports = require("opencv4nodejs");